import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=5fe993f2&"
import script from "./BlankView.vue?vue&type=script&lang=ts&"
export * from "./BlankView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports